module.exports = __webpack_public_path__ + "static/media/Barn-min.e8657a2b.PNG";